export const config = {
  token: {
    colorPrimary: "#045cac",
    // colorFillSecondary: "#045cac",
    colorFill: "#045cac",
  },
};
